import { SCENE_LOCATION } from '../constants';
import getOverlayPositionStyleClasses from './getOverlayPositionStyleClasses';
import valueToPercent from './valueToPercent';

function overlaySize(itemWidth, compositeWidth, itemHeight, compositeHeight) {
  const scale = 1;

  const heightVal = valueToPercent(itemHeight / compositeHeight, true);
  const widthVal = valueToPercent(itemWidth / compositeWidth, true);

  return { width: widthVal, height: heightVal, scale };
}

function overlaySizeWithAutoScale(itemWidth, compositeWidth, itemHeight, compositeHeight) {
  let scale = 1;

  let heightVal;
  let widthVal;

  //	Width is larger than composite
  if (itemWidth >= compositeWidth) {
    scale = compositeWidth / itemWidth;
    //	Scale the image to the width of the container
    widthVal = itemWidth * scale;
    heightVal = 'auto';
    // width = itemWidth;
  }
  // Height is larger than composite
  //	#note: unsure if we need scale here. i think it's needed when both sides are over the max size
  if (itemHeight * scale >= compositeHeight) {
    // can probably be changed to else if
    scale = compositeHeight / itemHeight;
    heightVal = itemHeight * scale;
    widthVal = 'auto';
  }

  //	if no values have been set yet, then item is less than composite size
  if (!widthVal && !heightVal) {
    //	In these cases, we have to set a value for only 1 property, otherwise it will skew
    if (itemWidth < compositeWidth) {
      widthVal = itemWidth / compositeWidth;
      heightVal = 'auto';
      // width = itemWidth * widthVal;
    } else if (itemHeight < compositeHeight) {
      heightVal = itemHeight / compositeHeight;
      widthVal = 'auto';
      // height = itemHeight * heightVal;
    }
    // --- by here, heightVal & widthValue should always be set

    //	for smaller items, convert to percentage -- NOT using "%" here
    heightVal = valueToPercent(heightVal, true);
    widthVal = valueToPercent(widthVal, true);
  }

  return { width: widthVal, height: heightVal, scale };
}

/**
 * Uses the given values to determine x/y positions for an item.
 *
 * @param {number} [value=17]
 * @param {number} [offsetX=0]
 * @param {number} [offsetY=0]
 * @param {number} [compositeWidth=1280]
 * @param {number} [compositeHeight=720]
 * @param {number} [itemWidth=0]
 * @param {number} [itemHeight=0]
 * @export
 * @returns {{height:number, width:number, top:number, right:number, bottom:number, left:number, originX:number, originY:number }} wefwef
 */
const getOverlayPositions = (
  value = 17,
  offsetX = 0,
  offsetY = 0,
  compositeWidth = 1280,
  compositeHeight = 720,
  itemWidth = 0,
  itemHeight = 0,
  location = 'normalizer',
  autoScaled = false
) => {
  // console.log(
  //   'getOverlayPositions::value, offsetX, offsetY, compositeWidth, compositeHeight, itemWidth, itemHeight, location',
  //   value,
  //   offsetX,
  //   offsetY,
  //   compositeWidth,
  //   compositeHeight,
  //   itemWidth,
  //   itemHeight,
  //   location
  // );
  // Bitmask:	111 0111 = 68
  // 17: Top Left
  // 18: Top Center
  // 20: Top Right
  // 33: Center Left
  // 34: Center Center
  // 36: Center Right
  // 65: Bottom Left
  // 66: Bottom Center
  // 68: Bottom Right

  /* eslint-disable no-param-reassign */
  offsetX = parseInt(offsetX, 10);
  offsetY = parseInt(offsetY, 10);
  compositeWidth = parseInt(compositeWidth, 10);
  compositeHeight = parseInt(compositeHeight, 10);
  /* eslint-enable no-param-reassign */

  // for now we allow user to set overlay size whatever, there will be size validation in future
  // const getOverlaySize = isVideoOverlay ? videoOverlaySize : imageOverlaySize;
  const getOverlaySize = autoScaled ? overlaySizeWithAutoScale : overlaySize;

  const {
    height: heightVal,
    width: widthVal,
    scale,
  } = getOverlaySize(itemWidth, compositeWidth, itemHeight, compositeHeight);

  const scaledWidth = itemWidth * scale;
  const scaledHeight = itemHeight * scale;

  const str = getOverlayPositionStyleClasses(value);

  let [originX, originY] = str.toLowerCase().split(' '); // gives us, e.g. "bottom left"

  //	strip out first char if "hcenter" or "vcenter"
  if (originX.indexOf('center') !== -1) {
    originX = originX.substr(1);
  }
  if (originY.indexOf('center') !== -1) {
    originY = originY.substr(1);
  }
  //	ignore offset for center
  const layout = {
    originX,
    originY,
    height: heightVal,
    width: widthVal,
  };

  if (originX === 'left') {
    layout.left = offsetX;
  } else if (originX === 'right') {
    layout.left = compositeWidth - scaledWidth - offsetX;
  } else if (originX === 'center') {
    const minWidth = Math.min(scaledWidth, compositeWidth);
    layout.left = (compositeWidth - minWidth) / 2 + offsetX;
  }
  if (originY === 'top') {
    layout.top = offsetY;
  } else if (originY === 'bottom') {
    layout.top = compositeHeight - scaledHeight - offsetY;
  } else if (originY === 'center') {
    layout.top = (compositeHeight - scaledHeight) / 2 + offsetY;
  }

  if (typeof layout.left !== 'undefined') {
    layout.left = valueToPercent(layout.left / compositeWidth, true);
  }
  if (typeof layout.top !== 'undefined') {
    layout.top = valueToPercent(layout.top / compositeHeight, true);
  }

  if (location === SCENE_LOCATION.PREVIEW) {
    if (typeof layout.width !== 'undefined' && typeof layout.width === 'number') {
      layout.width = valueToPercent(widthVal / compositeWidth, true);
    }
    if (typeof layout.height !== 'undefined' && typeof layout.height === 'number') {
      layout.height = valueToPercent(heightVal / compositeHeight, true);
    }
  }

  return layout;
};

export default getOverlayPositions;
